<template>
    <div>
        <card-header title="Participant Flights" icon="fa-plane"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-sliders-h" title="Report options"/>
                <container-list-item padded>
                    <div class="columns">
                        <div class="column">
                            <b-switch :true-value="1" :false-value="0" v-model="includeMissing">Include participants without flights</b-switch>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-switch :true-value="1" :false-value="0" v-model="includePassports">Include passport information</b-switch>
                        </div>
                    </div>
                    <div class="is-size-7 has-text-grey">
                        One row per flight with the passenger's contact details. Including
                        participants without flights appends a row per traveller who has no
                        flights assigned, marked <strong>NO FLIGHTS</strong>, so you can see
                        who still needs them. Passport information adds each traveller's
                        passport number, nationality, issue/expiry dates and issuing
                        authority.
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" @click="generate"><i class="fas fa-file-download mr-2"></i>Generate Report</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {apiUrl} from '@/http_client';
    import {mapGetters} from "vuex";

    // Report options card: pick the filters, then generate. The download
    // itself is the same authenticated GET the other report links use.
    export default {
        props: ['card', 'props'],
        components: {ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        data: function () {
            return {
                includeMissing: 0,
                includePassports: 0,
                apiUrl
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            generate() {
                let url = `${this.apiUrl}api/trips/${this.props.tripId}/reports/flights?auth=${this.currentUser.token}`;
                if (this.includeMissing) url += `&missing=1`;
                if (this.includePassports) url += `&passport=1`;
                window.open(url, '_blank');
            }
        },
        mounted() {
            this.$emit('loading', false);
        }
    };
</script>

<style lang="scss" scoped>

</style>
